import Promise from 'bluebird';
import _ from 'lodash';
import templates from '../../core/templates';
import { customScrollbar } from '../../shared';

// import 'mapbox.js';

export class CustomLegendLayer {
    static getTemplate (type, values) {
        if (_.isArray(type)) {
            return templates(`${type[0]}-${type[1]}`, values);
        } else {
            return templates(`map-${type}`, values);
        }
    }

    constructor ({ items, map, type, title, subtitle }) {
        this.map = map;
        this.items = items;
        this.type = type;
        this.title = title;
        this.subtitle = subtitle;

        this.add();
    }

    add () {
        // console.time('L.VectorLayer.LegendLayer -> add');
        try {
            this.create().then((template) => {
                if (this.destroyed) {
                    return;
                }

                this.remove();
                this.layerControl = L.control({ position: 'bottomleft' });
                this.layerControl.onAdd = () => template;
                this.map.addControl(this.layerControl);
            });
        } catch (err) {
            console.log('ERROR: ', err);
        }
        // console.timeEnd('L.VectorLayer.LegendLayer -> add');
    }

    remove () {
        // console.time('L.VectorLayer.LegendLayer -> remove');
        try {
            if (this.layerControl) {
                this.map.removeControl(this.layerControl);
                delete this.layerControl;
            }
        } catch (err) {
            console.log('ERROR: ', err);
        }
        // console.timeEnd('L.VectorLayer.LegendLayer -> remove');
    }

    create () {
        return new Promise((resolve, reject) => {
            // console.time('L.VectorLayer.LegendLayer -> create');

            const template = {
                title: this.title,
                subtitle: this.subtitle,
                items: this.items
            };

            const createTemplate = (name) => {
                const legend = $(CustomLegendLayer.getTemplate(name, template));
                resolve(legend[0]);

                if (_.size(template.items) > 12) {
                    setTimeout(() => customScrollbar(legend), 150);
                }

                legend.find('.legend-control').on('click', (e) => {
                    const $icon = $(e.target).closest('.layer-legend').find('.fa');
                    const $items = $(e.target).closest('.layer-legend').find('.legend-items');
                    if ($items.is(':visible')) {
                        $icon.removeClass('fa-minus-square').addClass('fa-plus-square');
                        $items.hide(700);
                    } else {
                        $icon.removeClass('fa-plus-square').addClass('fa-minus-square');
                        $items.show(700);
                    }
                });
                // console.timeEnd('L.VectorLayer.LegendLayer -> create');
            };

            if (this.type === 'polygon') {
                createTemplate('layer-legend-polygon');
            } else {
                createTemplate('layer-legend-point');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/CustomLegendLayer.js